import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import TableToolbar from './TableToolbar';
import Checkbox from './Checkbox';

var styles = function styles(theme) {
  return {
    selected: {
      '&$selected': {
        backgroundColor: '#FDF6ED',
        color: 'red'
      }
    },
    tableHead: {
      boxShadow: 'inset 0 -1px 0 0 #333940',
      maxHeight: '36px',
      height: '36px'
    },
    checkboxColumn: {
      width: '36px',
      paddingRight: '8px',
      paddingLeft: '16px'
    },
    row: {
      maxHeight: '36px',
      height: '36px'
    },
    tableCell: {
      padding: '4px 16px 4px 16px'
    }
  };
};

var DataTable =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataTable);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataTable)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      selected: undefined,
      order: undefined,
      orderBy: undefined,
      multipleSelection: {},
      onSelectionChange: function onSelectionChange() {}
    }, _this.componentWillReceiveProps = function (props) {
      _this.setState({
        selected: undefined,
        multipleSelection: {}
      });
    }, _this.handleChangeRowsPerPage = function (event) {
      var limit = _this.state.limit;

      if (limit !== event.target.value) {
        _this.setState({
          limit: event.target.value,
          offset: 0,
          updating: true
        }, _this.load);
      }
    }, _this.formatLink = function (link, data) {
      if (link === undefined) {
        return link;
      }

      return link.split('/').map(function (segment) {
        if (segment.startsWith(':')) {
          return data[segment.split(':')[1]];
        }

        return segment;
      }).join('/');
    }, _this.onClick = function (selected) {
      var link = _this.props.link;

      if (link !== undefined) {
        _this.setState({
          selected: selected
        });
      } else {
        _this.onSelect(selected);
      }
    }, _this.onSort = function (column) {
      return function () {
        var onSort = _this.props.onSort;
        var order = 'asc';

        if (_this.state.orderBy === column) {
          if (_this.state.order === 'asc') {
            order = 'desc';
          } else {
            // Clear sorting
            column = undefined;
            order = undefined;
          }
        }

        _this.setState({
          order: order,
          orderBy: column
        }, function () {
          if (onSort) {
            onSort(order, column);
          }
        });
      };
    }, _this.objToList = function (obj) {
      return Object.entries(obj).map(function (value) {
        return value[1];
      });
    }, _this.onSelect = function (row) {
      var _this$props = _this.props,
          multiSelectId = _this$props.multiSelectId,
          onSelectionChange = _this$props.onSelectionChange,
          onRowClick = _this$props.onRowClick;
      var multipleSelection = _this.state.multipleSelection;

      if (multiSelectId !== undefined) {
        if (multipleSelection.hasOwnProperty(row[multiSelectId])) {
          delete multipleSelection[row[multiSelectId]];
        } else {
          multipleSelection[row[multiSelectId]] = row;
        }
      }

      _this.setState({
        multipleSelection: multipleSelection
      }, function () {
        onSelectionChange && onSelectionChange(_this.objToList(multipleSelection));
        onRowClick && !multiSelectId && _this.onRowClick(row);
      });
    }, _this.onRowClick = function (row) {
      var onRowClick = _this.props.onRowClick;
      onRowClick(row);
    }, _this.onSelectAll = function () {
      var _this$props2 = _this.props,
          multiSelectId = _this$props2.multiSelectId,
          docs = _this$props2.docs,
          onSelectionChange = _this$props2.onSelectionChange;
      var multipleSelection = _this.state.multipleSelection;

      if (multiSelectId !== undefined) {
        if (Object.keys(multipleSelection).length === docs.length) {
          _this.setState({
            multipleSelection: {}
          }, function () {
            return onSelectionChange && onSelectionChange([]);
          });
        } else {
          docs.forEach(function (doc) {
            multipleSelection[doc[multiSelectId]] = doc;
          });

          _this.setState({
            multipleSelection: multipleSelection
          }, function () {
            return onSelectionChange && onSelectionChange(_this.objToList(multipleSelection));
          });
        }
      }
    }, _temp));
  }

  _createClass(DataTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selected = _this$state.selected,
          order = _this$state.order,
          orderBy = _this$state.orderBy,
          multipleSelection = _this$state.multipleSelection;
      var _this$props3 = this.props,
          docs = _this$props3.docs,
          mapping = _this$props3.mapping,
          multiSelectId = _this$props3.multiSelectId,
          link = _this$props3.link,
          classes = _this$props3.classes,
          empty = _this$props3.empty,
          search = _this$props3.search,
          searchFunction = _this$props3.searchFunction,
          title = _this$props3.title,
          tableSelectionActions = _this$props3.tableSelectionActions,
          tableActions = _this$props3.tableActions,
          selectedSimpleRow = _this$props3.selectedSimpleRow;
      return React.createElement(React.Fragment, null, selected && React.createElement(Redirect, {
        push: true,
        to: this.formatLink(link, selected)
      }), React.createElement(TableToolbar, {
        search: search,
        searchLive: search === 'live',
        searchFunction: searchFunction,
        title: title,
        actions: tableActions,
        multiActions: tableSelectionActions,
        selected: this.objToList(multipleSelection)
      }), (docs === undefined || docs.length === 0) && empty !== undefined && empty, docs !== undefined && docs.length > 0 && React.createElement(Table, null, React.createElement(TableHead, {
        className: classes.tableHead
      }, React.createElement(TableRow, {
        className: classes.row
      }, multiSelectId && multiSelectId.length > 0 && React.createElement(TableCell, {
        className: classes.checkboxColumn
      }, React.createElement(Checkbox, {
        checked: Object.keys(multipleSelection).length === docs.length,
        onChange: function onChange() {
          return _this2.onSelectAll();
        },
        indeterminate: Object.keys(multipleSelection).length < docs.length && Object.keys(multipleSelection).length > 0
      })), mapping.map(function (entry, index) {
        return React.createElement(TableCell, {
          className: classes.tableCell,
          key: index,
          align: entry.align,
          style: _extends({}, entry.style !== undefined ? entry.style : {})
        }, entry.sortable === true ? React.createElement(TableSortLabel, {
          active: orderBy === entry.column,
          direction: order,
          onClick: _this2.onSort(entry.column)
        }, React.createElement(Typography, null, React.createElement('b', null, entry.name))) : React.createElement(Typography, null, React.createElement('b', null, entry.name)));
      }))), docs && React.createElement(TableBody, null, docs.map(function (doc, index) {
        // Check if this row is selected
        var isChecked = multipleSelection.hasOwnProperty(doc[multiSelectId]);

        if (multiSelectId === undefined) {
          if (selectedSimpleRow !== undefined && selectedSimpleRow.id !== undefined) {
            isChecked = doc.id === selectedSimpleRow.id;
          }
        }

        return React.createElement(TableRow, {
          hover: link !== undefined,
          onClick: function onClick() {
            return _this2.onClick(doc);
          },
          key: index,
          selected: isChecked,
          classes: {
            selected: classes.selected
          },
          className: classes.row
        }, multiSelectId && multiSelectId.length > 0 && React.createElement(TableCell, {
          className: classes.checkboxColumn
        }, React.createElement(Checkbox, {
          checked: isChecked,
          onClick: function onClick(event) {
            event.stopPropagation();

            _this2.onSelect(doc);
          }
        })), mapping.map(function (entry, index) {
          return React.createElement(TableCell, {
            className: classes.tableCell,
            key: index,
            align: entry.align,
            style: _extends({}, mapping[index].style !== undefined ? mapping[index].style : {})
          }, React.createElement(Typography, _extends({}, isChecked ? {
            color: 'primary'
          } : {}, {
            component: 'span'
          }), entry.formatter ? entry.formatter(entry.computed ? entry.computed(doc) : doc[entry.column], doc) : entry.computed ? entry.computed(doc) : doc[entry.column]));
        }));
      }))));
    }
  }]);

  return DataTable;
}(Component);

export default withStyles(styles)(DataTable);